import { render, staticRenderFns } from "./MedicalRecord.vue?vue&type=template&id=21d9cb0a&scoped=true"
import script from "./MedicalRecord.vue?vue&type=script&lang=js"
export * from "./MedicalRecord.vue?vue&type=script&lang=js"
import style0 from "./MedicalRecord.vue?vue&type=style&index=0&id=21d9cb0a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d9cb0a",
  null
  
)

export default component.exports